export default "__VITE_ASSET__Df4SzKaL__"